"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeSymbol = exports.minimumDateAllowed = exports.maximumDateAllowed = exports.isValidDate = exports.formatMultipleDate = exports.formatDate = exports.formatByPattern = exports.convertToTwoString = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _ = require("./index.js");
var _regexPatterns = require("./regexPatterns.js");
const formatByPattern = (value, pattern) => {
  let separators = pattern.split(_regexPatterns.separatorRegex).filter(Boolean);
  let blockSizes = pattern.split(_regexPatterns.blockSizeRegex).filter(Boolean).map(b => b.length);
  let valueArray = removeSymbol(`${value}`).split('');
  let finalString = '';
  for (let index of blockSizes) {
    finalString = finalString + valueArray.splice(0, index).join('');
    if (valueArray.length > 0 && separators.length > 0) {
      finalString = finalString + separators.splice(0, 1);
    } else if (valueArray.length === 0) break;
  }
  return finalString;
};
exports.formatByPattern = formatByPattern;
const isValidDate = (dateString, format = _.DateFormatEnum.MM_DD_YYYY) => {
  let regex;
  switch (format) {
    case _.DateFormatEnum.MM_DD_YYYY:
      regex = _regexPatterns.dateRegexes.MM_DD_YYYY;
      break;
    case _.DateFormatEnum.DD_MM_YYYY:
      regex = _regexPatterns.dateRegexes.DD_MM_YYYY;
      break;
    case _.DateFormatEnum.DD_MM_YY:
      regex = _regexPatterns.dateRegexes.DD_MM_YY;
      break;
    case _.DateFormatEnum.MM_DD_YY:
      regex = _regexPatterns.dateRegexes.MM_DD_YY;
      break;
    case _.DateFormatEnum.MONTH_DD_YYYY:
      regex = _regexPatterns.dateRegexes.MONTH_DD_YYYY;
      break;
    case _.DateFormatEnum.WEEKDAY_MONTH_DD_YYYY:
      regex = _regexPatterns.dateRegexes.WEEKDAY_MONTH_DD_YYYY;
      break;
    case _.DateFormatEnum.DD_MMM_YYYY:
      regex = _regexPatterns.dateRegexes.DD_MMM_YYYY;
      break;
    default:
      regex = _regexPatterns.dateRegexes.MM_DD_YYYY;
  }
  return regex.test(dateString);
};
exports.isValidDate = isValidDate;
const removeSymbol = value => {
  return value.replace(_regexPatterns.symbolRegex, '');
};
exports.removeSymbol = removeSymbol;
const convertToTwoString = value => {
  if (value <= 9) return `0${value}`;
  return `${value}`;
};
exports.convertToTwoString = convertToTwoString;
const formatDate = (date, format = _.DateFormatEnum.MM_DD_YYYY) => {
  if (!date) return '';
  if (format === _.DateFormatEnum.WEEKDAY_MONTH_DD_YYYY) {
    const momentDate = (0, _moment.default)(date);
    const weekday = momentDate.format('dddd');
    const monthDayYear = momentDate.format('MMMM DD, YYYY');
    return `${weekday}, ${monthDayYear}`;
  }
  const isSupportedFormat = Object.values(_.DateFormatEnum).includes(format);
  if (!isSupportedFormat) {
    throw new Error(`Unsupported format: ${format}`);
  }
  return (0, _moment.default)(date).format(format);
};
exports.formatDate = formatDate;
const formatMultipleDate = (startdate, enddate, format) => {
  if (!startdate) return '';
  const newDate = new Date(startdate);
  const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const monthAbbreviations = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  const year = newDate.getFullYear();
  const month = convertToTwoString(newDate.getMonth() + 1);
  const day = convertToTwoString(newDate.getDate());
  const newEndDate = new Date(enddate);
  const yearEnd = newEndDate.getFullYear();
  const monthEnd = convertToTwoString(newEndDate.getMonth() + 1);
  const dayEnd = convertToTwoString(newEndDate.getDate());
  const monthName = monthNames[newDate.getMonth()];
  const monthNameEnd = monthNames[newEndDate.getMonth()];
  const weekdayName = dayNames[newDate.getDay()];
  const weekdayNameEnd = dayNames[newEndDate.getDay()];
  const monthNum = Number(month);
  const dayNum = Number(day);
  const yearNum = Number(year);
  const monthEndNum = Number(monthEnd);
  const dayEndNum = Number(dayEnd);
  const yearEndNum = Number(yearEnd);
  if (isNaN(monthNum) || isNaN(dayNum) || isNaN(yearNum) || isNaN(monthEndNum) || isNaN(dayEndNum) || isNaN(yearEndNum)) {
    return ' ';
  }
  switch (format) {
    case 'MM/DD/YYYY':
      return `${month}/${day}/${year}-${monthEnd}/${dayEnd}/${yearEnd}`;
    case 'DD/MM/YY':
      return `${day}/${month}/${year.toString().slice(2)}-${dayEnd}/${monthEnd}/${yearEnd.toString().slice(2)}`;
    case 'MM/DD/YY':
      return `${month}/${day}/${year.toString().slice(2)}-${monthEnd}/${dayEnd}/${yearEnd.toString().slice(2)}`;
    case 'Month DD, YYYY':
      return `${monthName} ${day}, ${year} - ${monthNameEnd} ${dayEnd}, ${yearEnd}`;
    case 'Weekday, Month DD, YYYY':
      return `${weekdayName}, ${monthName} ${day}, ${year} - ${weekdayNameEnd}, ${monthNameEnd} ${dayEnd}, ${yearEnd}`;
    case 'DD-MMM-YYYY':
      return `${day}-${monthAbbreviations[newDate.getMonth()]}-${year} - ${dayEnd}-${monthAbbreviations[newEndDate.getMonth()]}-${yearEnd}`;
    default:
      return `${month}/${day}/${year}-${monthEnd}/${dayEnd}/${yearEnd}`;
  }
};
exports.formatMultipleDate = formatMultipleDate;
const currentDate = new Date();
const future = new Date(currentDate);
future.setFullYear(future.getFullYear() + 100);
const formattedFuture = future.toDateString() + ' ' + future.toTimeString().slice(0, 8) + ' GMT+0530 (India Standard Time)';
const maximumDateAllowed = exports.maximumDateAllowed = new Date(formattedFuture);
const minimumDateAllowed = exports.minimumDateAllowed = new Date('1900-01-01T00:00:00+05:30');
;